var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Qr" },
    [
      _c("vue-qr", {
        attrs: {
          bgSrc: _vm.bgSrc,
          logoSrc: _vm.logoSrc,
          logoScale: 20,
          text: _vm.text,
          size: _vm.size,
          margin: 0.2,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }